import {
    getVisualCardType,
    type VisualCardType,
} from '../../../utils/getVisualCardType';
import { isQuestionItem } from '../../state-type-guards';
import type { StoreState } from '../../state-types';

/** Get card visual type */
export const getCardVisualType =
    (cardId: string) =>
    (state: StoreState): VisualCardType => {
        const card = state.actions.getCard(cardId);
        if (!card) {
            return 'titleCard';
        }

        if (!isQuestionItem(card)) {
            return card.type;
        }

        const { type, formType } = card;
        return getVisualCardType({ type, formType });
    };
